import _ from 'lodash';
import SignIn from '../SignIn/signIn.js';
import { oidcSettings } from '../SettingsManager/settingsManager.js';
import IFrameManager from '../IFrameManager/iFrameManager.js';

const defaults = {
    silentRequestTimeout: 10 // 10 sec
};

let iFrameManager;
const silentRenew = (function (settings) {
    settings = _.extend({}, defaults, settings);
    oidcSettings(settings)
        .then((config) => {
            iFrameManager = IFrameManager();
            const isInIFrame = (window.location != window.parent.location);

            if (isInIFrame === false) {
                const signIn = new SignIn(config);
                signIn.signInSilentRequest_v2()
                    .then((silentAuthUri) => {
                        const authUri = silentAuthUri;
                        iFrameManager
                            .loadSilentRenewIFrame(authUri);
                        const silentRequestTimeout = settings.silentRequestTimeout * 1000;
                        iFrameManager.removeIFrameOnTimeout(silentRequestTimeout, 'silent-renew-iframe');
                    });
            }
            return Promise.resolve();
        });
});


export default silentRenew;